import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faUserDoctor,
  faUsers,
  faHeart,
  faEye,
  faCheck,
  faHeadphones,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./ChiSonoPage.css";

const ChiSonoPage: React.FC = () => {
  const values = [
    {
      icon: faGraduationCap,
      title: "Formazione Eccellente",
      description:
        "Laurea in Medicina e Chirurgia, con specializzazione in Otorinolaringoiatria presso Centri di riferimento per le patologie di orecchio, naso e gola.",
    },
    {
      icon: faUserDoctor,
      title: "Aggiornamento Continuo",
      description:
        "Partecipazione costante a congressi nazionali e internazionali.",
    },
    {
      icon: faUsers,
      title: "Approccio Umano",
      description:
        "Ogni paziente è unico, merita ascolto e cure personalizzate.",
    },
    {
      icon: faHeart,
      title: "Passione e Dedizione",
      description: "La salute dei miei pazienti è la mia priorità assoluta.",
    },
  ];

  return (
    <div className="chi-sono-page">
      {/* Header Section */}
      <section className="chi-sono-header">
        <div className="chi-sono-header-container">
          <p className="chi-sono-header-label">CHI SIAMO</p>
        </div>
      </section>

      <section className="patologie-cards-section">
        <div className="patologie-cards-container chi-sono-cards-container ">
          {/* Patologie dell'Orecchio */}
          <div
            id="gianfrancoMattina"
            className="patologie-card"
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <img
              src={require("../assets/photos/main-photo.jpg")}
              alt="Gianfranco Mattina"
              style={{
                width: 300,
                height: 400,
                borderRadius: 12,
                marginBottom: 24,
              }}
            />
            <h2 className="service-detail-title">Gianfranco Mattina</h2>
            <div className="chi-sono-text">
              <h2 className="chi-sono-subtitle">
                Specialista in Otorinolaringoiatria
              </h2>
              <p className="chi-sono-paragraph">
                Sono specialista in Otorinolaringoiatria con oltre 10 anni di
                esperienza nella diagnosi e nel trattamento delle patologie di
                orecchio, naso e gola.
              </p>
              <p className="chi-sono-paragraph">
                Il mio approccio combina competenze mediche avanzate con una
                profonda attenzione al rapporto umano con il paziente. Credo
                fermamente che l'ascolto e la comprensione siano fondamentali
                per un percorso di cura efficace.
              </p>
              <p className="chi-sono-paragraph">
                Durante la mia carriera, ho avuto il privilegio di aiutare
                migliaia di pazienti a risolvere problematiche che impattavano
                significativamente sulla loro qualità di vita. La soddisfazione
                più grande è vedere un paziente tornare a sentire bene,
                respirare liberamente o parlare senza difficoltà.
              </p>
            </div>
          </div>

          {/* Patologie della Gola */}
          <div
            id="caterinaRomano"
            className="patologie-card"
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <div
              style={{
                width: 300,
                height: 400,
                borderRadius: 12,
                marginBottom: 24,
                background: "#5a8b85",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 32,
                fontWeight: 600,
                letterSpacing: 1,
                justifySelf: "center",
              }}
            >
              <FontAwesomeIcon icon={faUser} size="3x" color="#7fb3ad" />
            </div>
            <h2 className="service-detail-title">Caterina Romano</h2>
            <div className="chi-sono-text">
              <h2 className="chi-sono-subtitle">
                Responsabile Amministrativa e di Segreteria
              </h2>
              <p className="chi-sono-paragraph">
                Specializzata nella gestione amministrativa e della segreteria
                garantendo un’organizzazione efficiente e puntuale. È il primo
                punto di contatto per i pazienti, che accoglie con
                professionalità, disponibilità e attenzione.
              </p>
              <p className="chi-sono-paragraph">
                Il suo contributo è fondamentale per assicurare un servizio
                ordinato, fluido e orientato al benessere di chi si rivolge al
                Centro.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="chi-sono-values">
        <div className="chi-sono-values-container">
          <h2 className="chi-sono-values-title">I Miei Valori</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-card-icon">
                  <FontAwesomeIcon icon={value.icon} />
                </div>
                <h3 className="value-card-title">{value.title}</h3>
                <p className="value-card-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="chi-sono-cta">
        <div className="chi-sono-cta-container">
          <h2 className="chi-sono-cta-title">Vuoi Prenotare una Visita?</h2>
          <p className="chi-sono-cta-description">
            Contattami per fissare un appuntamento o per maggiori informazioni
            sui servizi offerti.
          </p>
          <div className="chi-sono-cta-buttons">
            <Link to="/contatti" className="btn-primary-cta">
              Prenota Ora
            </Link>
            <Link to="/servizi" className="btn-secondary-cta">
              Scopri i Servizi
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChiSonoPage;
